export const locales = {
  Russian: {
    errorMessage: 'Неожиданная ошибка',
  },
  English: {
    errorMessage: 'Something is wrong',
  },
};
